import { Flex, Table, type TableProps } from 'antd'

import { TrashIcon } from '@phosphor-icons/react'
import { PublisherService } from '@services/PublisherService'
import { useConfirmation } from '@store/confirmation'
import { useNotifications } from '@store/notifications'

import type { Invitee } from '../../../types'

export const InvitesTable = ({
    invitees,
    publisherId,
    refetch
}: {
    invitees?: Invitee[]
    publisherId?: string
    refetch: () => Promise<void>
}) => {
    const confirm = useConfirmation()
    const { showNotification } = useNotifications()

    const handleRemove = async (inviteId: string) => {
        if (
            await confirm({
                title: 'Are you sure you want to remove this invite?',
                confirmText: 'Remove'
            })
        ) {
            try {
                await PublisherService.removeInvite(publisherId!, inviteId)
                showNotification({ title: 'Invite removed' })
                await refetch()
            } catch (err) {
                showNotification({ title: 'Error removing invite', type: 'error' })
            }
        }
    }

    const columns: TableProps<Invitee>['columns'] = [
        {
            title: 'Email',
            key: 'email',
            render: (_, { email }) => <>{email}</>
        },
        {
            title: 'Publisher Role',
            key: 'role',
            render: (_, { claims }) => {
                const claim = claims?.find(c => c.publisherRole)
                return <>{claim?.publisherRole}</>
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, { id }) => (
                <Flex gap="middle" align="center">
                    <TrashIcon size={20} color="red" onClick={() => handleRemove(id)} cursor="pointer" />
                </Flex>
            )
        }
    ]

    if (!publisherId || !invitees) {
        return <div>Empty</div>
    }
    return <Table columns={columns} dataSource={invitees || []} rowKey="id" pagination={{ pageSize: 50 }} />
}
